import { type ReactNode, useState } from 'react';

import { EventKey } from 'types/tickets.types';

import { NofomoCartStoreContext } from './context';
import {
  createCartStore,
  initNofomoCartStore,
  type NofomoCartStoreReturnType,
} from './zustand';

interface CartStoreProviderProps {
  eventKey: EventKey;
  children: ReactNode;
}

export const CartStoreProvider = ({
  eventKey,
  children,
}: CartStoreProviderProps) => {
  const [store] = useState<NofomoCartStoreReturnType>(() =>
    createCartStore(initNofomoCartStore({ eventKey })),
  );

  return (
    <NofomoCartStoreContext.Provider value={store}>
      {children}
    </NofomoCartStoreContext.Provider>
  );
};
